<template>
	<div class="field">
		<label class="label">{{ label }}</label>
		<div class="control">
			<multiselect
				track-by="id"
				label="name"
				:options="hospitals"
				:value="myValue"
				:searchable="true"
				:loading="isFetching"
				deselect-label="Press enter to clear"
				:data-test="`${name}`"
				@input="myBlur"
			/>
		</div>
		<p v-if="showError" class="help is-danger" :data-test="`error-${name}`">
			{{ error }}
		</p>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import fieldMixin from "@lab/utils/fieldMixin";
import { sortBy } from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
	components: { Multiselect },
	mixins: [fieldMixin],
	props: {
		label: {
			type: String,
			default: () => "Hospitals"
		},
		healthserviceId: {
			type: Number,
			default: () => null
		}
	},
	computed: {
		...mapGetters({
			storeHospitals: "hospitalsModule/get",
			IsFetching: "hospitalsModule/IsFetching"
		}),
		myValue() {
			return this.hospitals.find((o) => o.id === this.value);
		},
		hospitals() {
			const hospitals = this.healthserviceId
				? this.storeHospitals.filter(
						(hospital) =>
							hospital.healthserviceid === this.healthserviceId
				  )
				: this.storeHospitals;
			return sortBy(hospitals, ["name"]);
		},
		isFetching() {
			return this.IsFetching;
		}
	},
	created() {
		this.fetchHospitals();
	},
	methods: {
		...mapActions("hospitalsModule", ["fetchHospitals"]),
		myBlur(org) {
			const val = org ? org.id : null;
			this.blur(val);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";
</style>
